<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">

      <el-form class="com-search-box" ref="form" label-position="left" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item class="el-form-state" label="关键字 :" prop="key" placeholder="请输入">
              <el-input v-model="form.key"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="选择日期 :" prop="date">
              <el-date-picker v-model="form.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>

          <el-button round @click="exportList">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button>

          <el-button type="primary" plain round @click="checkVerification">
            <i class="el-icon-edit"></i>&nbsp;核销未打卡记录
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column prop="username" label="姓名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="预约服务类型" min-width="8%">
          </el-table-column>
          <el-table-column prop="appointmentDate" label="活动时间" min-width="13%"></el-table-column>
          <el-table-column prop="exhibitionName" label="预约服务名称" min-width="16%"></el-table-column>
          <el-table-column prop="appointmentTime" label="预约服务时间" min-width="10%"
            show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="isCheck" label="是否签到" min-width="7%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.isCheck == '0' ? '否' : '是' }}</template>
</el-table-column> -->
          <el-table-column prop="checkTimeBegin" label="到馆时间" min-width="12%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="checkTimeEnd" label="离馆时间" min-width="12%" show-overflow-tooltip></el-table-column>

          <!-- <el-table-column prop="schemeNumber" label="状态" min-width="6%">
            <template slot-scope="scope">
              <span>已注册</span>
            </template>
          </el-table-column>-->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="18%">
            <template slot-scope="scope">
              <span>
                <!-- v-if="!scope.row.checkTimeBegin" -->
                <a class="m-btn mr-10" @click="sign(scope.row, '1')">签到</a>
                <a class="m-btn mr-10" @click="sign(scope.row, '2')">离场</a>
                <!-- <a class="m-danger" @click="sign(scope.row, '3')">打卡校验</a> -->
              </span>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.page" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>

      <el-dialog title="选择核销日期" :visible="checkVisible" width="20%" @close="cancel1" :close-on-click-modal="false">
        <el-form class="g-form-grid" ref="checkForm" :model="checkForm" :rules="checkRules">
          <el-form-item class="time-select w-100" prop="date">
            <el-date-picker class="w-100" v-model="checkForm.date" value-format="yyyy-MM-dd" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="footer mt-30 flex-box">
          <el-button @click="cancel1">取消</el-button>
          <el-button @click="submit1" type="primary" :loading="loadingCheck">确定</el-button>
        </div>
      </el-dialog>



      <el-dialog :title="signType == 1 ? '签到' : '离场'" :visible="signVisible" width="20%" @close="cancel"
        :close-on-click-modal="false">
        <el-form class="g-form-grid" ref="signForm" :model="signForm" label-width="90px" :rules="rules">
          <el-form-item label="到馆时间 :" v-if="signType != 2" prop="beginTime">
            <el-date-picker v-model="signForm.beginTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
              type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="离馆时间 :" v-if="signType != 1" prop="endTime">
            <el-date-picker v-model="signForm.endTime" type="datetime" format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="footer mt-30 flex-box">
          <el-button @click="cancel">取消</el-button>
          <el-button @click="checkUserTime" type="primary" :loading="loadingCheckTime">校验</el-button>
          <el-button @click="fromSubmit" type="primary" :loading="loadingSave">确定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    // dialogActivityInfo,
    // dialogQrcode
  },
  data() {
    return {
      that: this,
      form: {
        date: '',
        key: ''
      },
      signType: '',
      signForm: {},
      signObj: {},
      signVisible: false,
      loadingSave: false,
      loadingCheck: false,

      loadingCheckTime: false,
      rules: {
        beginTime: [
          { required: true, message: '到馆时间不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '离馆时间不能为空', trigger: 'blur' }
        ]
      },

      checkVisible: false,
      checkForm: {
        date: '',
      },
      checkRules: {
        date: [{ required: true, message: '核销时间不能为空', trigger: 'blur' }
        ],
      },

      listLoading: true,
      listQuery: {
        page: 1,
        size: 10
      },
      total: 0,
      tableData: []
    }
  },
  filters: {
    filterVolunteerRecruit(status, context) {
      let arr = context.statusList.filter((item) => {
        return item.dictCode == status
      })

      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$api.volunteer
        .getCheckList({
          ...this.form,
          ...this.listQuery
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            if (res.result) {
              this.tableData = res.result.records || []
              this.total = res.result.total || 0
            } else {
              this.$message.error(res.message)
            }
          }
        })
    },

    cancel() {
      this.$refs.signForm.resetFields()
      this.signVisible = false
      this.signForm = {}
      this.signObj = {}
    },

    cancel1() {
      this.$refs.checkForm.resetFields()
      this.checkVisible = false
    },

    submit1() {
      this.$refs['checkForm'].validate((valid) => {
        if (valid) {
          this.loadingCheck = true
          this.$http.get('/v2/bsVolunteerV2ExhibitionDetailUser/checkVerification', { date: this.checkForm.date }).then(res => {
            if (res.success) {
              this.$message.success(res.message || '核销成功')
              this.cancel1()
            } else {
              this.$message.error(res.message || '核销失败')
            }
            this.loadingCheck = false
          }).catch(err => {
            this.loadingCheck = false
          })
        }
      })
    },

    fromSubmit() {
      if (this.signType == 1) {
        delete this.signForm.endTime
      } else if (this.signType == 2) {
        delete this.signForm.beginTime
      }
      this.$refs['signForm'].validate((vaild) => {
        if (vaild) {
          this.loadingSave = true
          this.$api.volunteer
            .volunteerCheck({
              id: this.signObj.id,
              activityDate: this.signObj.appointmentDate,
              sign: this.signObj.sign,
              ...this.signForm
            })
            .then((res) => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success(
                  this.signType == 1 ? '签到成功' : '离场签到成功'
                )
                this.cancel()
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.page = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.page = 1
      this.initList()
    },

    async checkUserTime() {
      this.loadingCheckTime = true
      let volunteerTimeList = await this.checkTime()
      if (volunteerTimeList && volunteerTimeList.length >= 2) {
        if (this.signType == 1) {
          this.signForm.beginTime = this.$common.formatDateString(volunteerTimeList[0].checkTime, 'yyyy-MM-dd HH:mm')
        } else if (this.signType == 2) {
          this.signForm.endTime = this.$common.formatDateString(volunteerTimeList[volunteerTimeList.length - 1].checkTime, 'yyyy-MM-dd HH:mm')
        }
      } else {
        this.$message.warning('未校验到打卡时间，请手动选择')
      }
      this.loadingCheckTime = false

    },

    checkTime() {
      return new Promise((resolve, reject) => {
        this.$api.volunteer.volunteerCheckTime({ date: this.signObj.appointmentDate, name: this.signObj.username }).then(res => {
          if (res.success) {
            resolve(res.result)
          }
        })
      })
    },

    sign(obj, type) {
      if (type == 1) {
        this.signForm = { beginTime: '' }
        if (obj.checkTimeBegin) {
          this.signForm.beginTime = this.$common.formatDateString(obj.checkTimeBegin, 'yyyy-MM-dd HH:mm')
        } else {
          this.signForm.beginTime = this.$common.formatDateString(new Date(), 'yyyy-MM-dd HH:mm')
        }
      }
      if (type == 2) {
        this.signForm = { endTime: '' }
        if (obj.checkTimeEnd) {
          this.signForm.endTime = this.$common.formatDateString(obj.checkTimeEnd, 'yyyy-MM-dd HH:mm')
        } else {
          this.signForm.endTime = this.$common.formatDateString(new Date(), 'yyyy-MM-dd HH:mm')
        }
      }

      this.signType = type
      this.signVisible = true
      this.signObj = obj
    },

    // 导出
    exportList() {
      window.location.href = `/singleMuseum/v2/bsVolunteerV2ExhibitionDetailUser/export?page=${this.listQuery.page}&size=${this.listQuery.size}&date=${this.form.date}&key=${this.form.key}`
    },

    checkVerification() {
      this.checkVisible = true
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach((item) => {
        arr.push(item.schemeId)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.initList()
    window.addEventListener('keyup', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .el-form-state {
    /deep/ .el-form-item__label {
      width: 70px !important;
    }

    /deep/ .el-form-item__content {
      margin-left: 70px !important;
    }
  }

  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;

      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}

/deep/ .footer {
  justify-content: flex-end;
}
</style>